import { render } from "./Loadingtable.vue?vue&type=template&id=2bed30f4"
import script from "./Loadingtable.vue?vue&type=script&lang=js"
export * from "./Loadingtable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__